"use client";

import { createContext, useContext } from "react";

const Direct130HostContext = createContext(false);

/** Set by a server layout from the Host header, so the first render on Direct 130's address is already Direct 130. */
export function Direct130HostProvider({ value, children }: { value: boolean; children: React.ReactNode }) {
  return <Direct130HostContext.Provider value={value}>{children}</Direct130HostContext.Provider>;
}

export const useDirect130Host = () => useContext(Direct130HostContext);
